import { type StoreApiModel, type StoreModel } from '@/types/StoreModel'
import extractData from '@/utils/extractData'
import { normalizeOwnBrandIds } from '@/views/dashboard/domain/ownBrandIds'
import type { LeafletForm } from '@/views/dashboard/types/LeafletForm'

import { geolocationsApiToModel, geolocationsModelToApi } from '../adapters/geolocationsAdapter'
import { leafletsMapper } from '../mappers/leaflets/leafletsMapper'
import { addNewShop, editShop, getAllShops, getShop, getShopLeaflets, postLeafletToStore } from '../shops'
import { expectLeafletMutationStatus } from './leafletMutationStatus'

function storeApiToModel(payload: StoreApiModel): StoreModel {
  return {
    ...geolocationsApiToModel(payload),
    ownBrandIds: normalizeOwnBrandIds(payload.ownBrandIds)
  }
}

function storeModelToApi(payload: StoreModel): StoreApiModel {
  return {
    ...geolocationsModelToApi(payload),
    ownBrandIds: normalizeOwnBrandIds(payload.ownBrandIds)
  }
}

export async function addLeafletToStore(payload: LeafletForm, storeId: StoreModel['id'], watermark: boolean) {
  const apiPayload = leafletsMapper.mapLeafletUpdateToApi(payload)
  const result = await postLeafletToStore(apiPayload, storeId, watermark)
  return extractData(expectLeafletMutationStatus(result, 201))
}

export async function fetchShopsLeaflets(storeId: StoreModel['id']) {
  const response = await getShopLeaflets(storeId)
  const data = extractData(response)
  return leafletsMapper.mapLeafletListFromApi(data)
}

export async function fetchShops(params?: Record<string, string>) {
  const result = await getAllShops(params)
  const extractedData = extractData(result)
  const data: StoreModel[] = extractedData.map(storeApiToModel)

  return data
}

export async function fetchShop(shopId: StoreModel['id']) {
  const result = await getShop(shopId)
  const extractedData = extractData(result)
  const data: StoreModel = storeApiToModel(extractedData)

  return data
}

export async function createShop(payload: StoreModel) {
  const apiPayload: StoreApiModel = storeModelToApi(payload)
  const result = await addNewShop(apiPayload)

  return extractData(result)
}

export async function updateShop(payload: StoreModel) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { leaflets, ...apiPayload } = storeModelToApi(payload)
  return editShop(apiPayload)
}
